import { Box, Modal } from "@mui/material";
import React, { useCallback, useState } from "react";

import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

// import NutritionCarePlan from "./NutritionCarePlan";

import { ModalStyle } from "../../../../common/components/modalstyle/ModalStyle";
import { CloseModalIcon } from "../../../../common/components/assets/commonassets/CommonAssets";
import CommonDivider from "../../../../common/components/divider/CommonDivider";
import CommonBackDrop from "../../../../common/components/CommonBackDrop/CommonBackDrop";
import FeedingSchedule from "./FeedingSchedule";

const dietTabs = [
  { id: 1, label: "RT Feeds" },
  // { id: 2, label: "Nutrition Assessment" },
  { id: 3, label: "Nutrition Care Plan" },
];

const PatientInfo = {
  "Patient Name": "Mr. Vaibhav R Bhosale",
  UHID: "PVLIMI1442",
  Age: "32Y 11M 21D",
  Department: "E N T",
  Doctor: "Dr. Ravi Kumar",
};

function DieatFoodAssesmentModal(props) {
  const { openDietFoodAssModal, setOpenDietFoodAssModal, selectedRow } = props;

  const defaultValues = { date: new Date() };

  const schema = yup.object().shape({});

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    clearErrors,
    watch,
    getValues,
    setError,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(schema),
  });

  const [postConfirmationModal, setPostConfirmationModal] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [finalObject, setFinalObject] = useState(null);
  const [activeTab, setActiveTab] = useState(1);
  const [patientInfo, setPatientinfo] = useState(PatientInfo);
  const [scheduleFeedingData, setScheduleFeedingData] = useState([]);
  const [deletedScheduleFedData, setDeletedSheduleFedData] = useState([]);

  const handleSaveClick = (data) => {
    let tempobj = {
      admissionId: 1,
      empId: 1,
      feeds: [],
    };
    setFinalObject(tempobj);
    console.log("tempObjj", tempobj);

    setPostConfirmationModal(true);

    console.log("data from the form", data);
  };
  const onSubmit = () => {
    setPostConfirmationModal(false);
    // setIsBackdrop(true);   backdrop state
    // saveVisitor(finalObject)
    //   .then((response) => response.data)
    //   .then((res) => {
    //     if (res.statusCode === 200 || res.statusCode === 201) {
    //       successAlert(res?.message);
    //       setPostConfirmationModal(false);
    //       reset(defaultValues);
    //       setFinalObject(null);
    //       setICUCheckList(ObstetricItems);
    //     } else {
    //       errorAlert(res?.message);
    //     }
    //     // setIsBackdrop(false);  backdrop state
    //   })
    //   .catch((error) => {
    //     errorAlert(error?.message);
    //     // setIsBackdrop(false);      backdrop state
    //   });
  };
  React.useEffect(() => {
    if (selectedRow !== null) {
      setPatientinfo({
        "Patient Name": selectedRow?.patientName,
        "Mr.No": selectedRow?.mrNo,
        Age: selectedRow?.age,
        "Bed No": selectedRow?.bedNo,
        "Doctor Name": selectedRow?.doctorName,
      });
    }
  }, [selectedRow]);
  return (
    <Modal
      open={openDietFoodAssModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={ModalStyle}
        className="w-[85%] h-[90%] max-h-[90%] overflow-y-auto "
      >
        <div className="flex justify-between  items-center mb-1">
          <h1 className=" font-semibold text-[17px]">Diet Food/Assesment</h1>
          <CloseModalIcon
            type={"button"}
            onClick={() => {
              setOpenDietFoodAssModal(false);
            }}
          />
        </div>
        <div className="">
          <CommonDivider color="#E0E0E0" />
        </div>
        {patientInfo && (
          <div className="rounded-md shadow bg-[#ECF4FF] border border-[#8d96f5] p-2  my-2">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3  gap-2 text-sm">
              {Object.entries(patientInfo)?.map(([key, value]) => (
                <div
                  key={key}
                  className="grid  grid-cols-[40%_3%_56%] xl:grid-cols-[32%_3%_65%]"
                >
                  <div className="font-semibold text-gray-600 whitespace-nowrap">
                    {key}
                  </div>

                  <div className="font-semibold text-[#073763]">:</div>

                  <div className="font-semibold text-[#073763] break-words">
                    {value || "-"}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        <div className="flex gap-3 items-center">
          {/* <div className="">
            <DatePickerField
              control={control}
              label="Date"
              name="date"
              inputFormat="dd-MM-yyyy"
              disablePast={true}
              slotProps={{ textField: { size: "small" } }}

              // error={errors?.startDate}
            />
          </div> */}
          {/* <div className="flex gap-2 items-center bg-gray-200 rounded-lg pt-1 pb-1 pr-1 pl-0 w-full">
            {dietTabs.map((tab) => {
              const isActive = activeTab === tab.id;

              return (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => setActiveTab(tab?.id)}
                  className={`
          px-5 py-2 text-sm font-medium rounded-md
          transition-all duration-300 ease-in-out
          ${
            isActive
              ? " text-white bg-sky-800   shadow-sm scale-[1.03] font-semibold"
              : "text-gray-600 hover:text-gray-700"
          }
        `}
                >
                  {tab.label}
                </button>
              );
            })}
          </div> */}
        </div>
        {/* <form onSubmit={handleSubmit(handleSaveClick)}> */}
        <div className="my-2">
          {/* {activeTab === 1 && ( */}
          <FeedingSchedule
            scheduleFeedingData={scheduleFeedingData}
            deletedScheduleFedData={deletedScheduleFedData}
            setDeletedSheduleFedData={setDeletedSheduleFedData}
            setScheduleFeedingData={setScheduleFeedingData}
            setOpenBackdrop={setOpenBackdrop}
            setActiveTab={setActiveTab}
            setOpenDietFoodAssModal={setOpenDietFoodAssModal}
            selectedRow={selectedRow}
          />
          {/* )} */}
          {/* {activeTab === 3 && (
            <NutritionCarePlan
              setOpenBackdrop={setOpenBackdrop}
              setActiveTab={setActiveTab}
            />
          )} */}
        </div>
        {/* <div className="flex justify-end gap-3  mt-3 ">
            <CommonButton
              type="button"
              label="Reset"
              className="resetButton text-customRed border border-customRed"
              onClick={() => {
                reset(defaultValues);
              }}
            />
            <CommonButton
              type="submit"
              label="Save"
              className="saveButton bg-customGreen text-white "
            />
          </div> */}
        {/* </form> */}
        {/* {postConfirmationModal && (
          <ConfirmationModal
            confirmationOpen={postConfirmationModal}
            confirmationHandleClose={() => setPostConfirmationModal(false)}
            confirmationSubmitFunc={onSubmit}
            confirmationMsg={`Are you sure to save the investigation form?`}
            confirmationButtonMsg={"Confirm"}
            confirmationLabel={"Confirmation"}
          />
        )} */}

        {<CommonBackDrop openBackdrop={openBackdrop} />}
      </Box>
    </Modal>
  );
}

export default DieatFoodAssesmentModal;
